import React, { createContext, useContext, useMemo } from "react";
import invariant from "tiny-invariant";
var QuestionDescriptionId;
(function (QuestionDescriptionId) {
    QuestionDescriptionId["QUIZ_SIZE_GUIDE"] = "quiz-size-guide";
    QuestionDescriptionId["QUIZ_SILHOUETTE_GUIDE"] = "quiz-silhouette-guide";
    QuestionDescriptionId["QUIZ_STYLE_DESCRIPTION"] = "quiz-style-description";
    QuestionDescriptionId["QUIZ_PHOTOS_DESCRIPTION"] = "quiz-photos-description";
    QuestionDescriptionId["QUIZ_ITEMS_LOOKING_FOR_HINT"] = "quiz-items-looking-for-hint";
    QuestionDescriptionId["STYLE_PROFILE_SIZE_GUIDE"] = "style-profile-size-guide";
    QuestionDescriptionId["STYLE_PROFILE_SILHOUETTE_GUIDE"] = "style-profile-silhouette-guide";
    QuestionDescriptionId["STYLE_PROFILE_STYLE_DESCRIPTION"] = "style-profile-style-description";
    QuestionDescriptionId["STYLE_PROFILE_PHOTOS_DESCRIPTION"] = "style-profile-photos-description";
    QuestionDescriptionId["STYLE_PROFILE_SOCIAL_DESCRIPTION"] = "style-profile-social-description";
    QuestionDescriptionId["STYLE_PROFILE_ITEMS_LOOKING_FOR_HINT"] = "style-profile-items-looking-for-hint";
    QuestionDescriptionId["STYLE_PROFILE_INSPIRATION_DESCRIPTION"] = "style-profile-inspiration-description";
})(QuestionDescriptionId || (QuestionDescriptionId = {}));
const QuestionDescriptionContext = createContext(null);
const QuestionDescriptionProvider = ({ domain, children, questionDescriptions, i18nPrefix, portalHostName, tradename, segment, onOpenSilhouetteGuide, onOpenSizeGuide, }) => {
    const value = useMemo(() => ({
        domain,
        questionDescriptions,
        i18nPrefix,
        portalHostName,
        tradename,
        segment,
        onOpenSilhouetteGuide,
        onOpenSizeGuide,
    }), [
        domain,
        i18nPrefix,
        onOpenSilhouetteGuide,
        onOpenSizeGuide,
        portalHostName,
        questionDescriptions,
        segment,
        tradename,
    ]);
    return React.createElement(QuestionDescriptionContext.Provider, { value: value }, children);
};
const wrapper = (Component) => ({ domain, i18nPrefix, portalHostName, tradename, segment, onOpenSilhouetteGuide, onOpenSizeGuide }) => (React.createElement(Component, { domain: domain, i18nPrefix: i18nPrefix, portalHostName: portalHostName, segment: segment, tradename: tradename, onOpenSilhouetteGuide: onOpenSilhouetteGuide, onOpenSizeGuide: onOpenSizeGuide }));
const useQuestionDescription = ({ id }) => {
    const { domain, questionDescriptions, i18nPrefix, portalHostName, segment, tradename, onOpenSilhouetteGuide, onOpenSizeGuide, } = useContext(QuestionDescriptionContext);
    const description = useMemo(() => questionDescriptions[id], [questionDescriptions, id]);
    invariant(questionDescriptions, "Your are trying to use the useQuestionDescription hook without wrapping your app with the <QuestionDescriptionProvider>.");
    invariant(description, `The provided id (${id}) is NOT SUPPORTED`);
    return wrapper(description)({
        domain,
        i18nPrefix,
        portalHostName,
        tradename,
        segment,
        onOpenSilhouetteGuide,
        onOpenSizeGuide,
    });
};
export { useQuestionDescription, QuestionDescriptionProvider, QuestionDescriptionId };
